import React, { Component } from "react";
import { Divider, Breadcrumb, Container } from "semantic-ui-react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Helmet } from "react-helmet";
import { SyncLoader } from "react-spinners";
import moment from "moment";

import {
  FIND_CLUB_ROUTE,
  HOME_ROUTE,
  CLUBS_ROUTE,
  BASE_URL
} from "../../constants/route.constants";
import { APP_NAME } from "../../constants/resource.constants";
import { getParsedRouteParam, capitaliseFirstLetters } from "../../utility";
import Club from "../../components/Club/Club";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/FooterView";

export default class ClubPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      country: "",
      state: "",
      isLoading: true
    };
  }

  componentWillUnmount() {
    this.setState({
      name: "",
      country: "",
      state: "",
      isLoading: true
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.clubs !== prevProps.clubs) {
      this.setState({
        isLoading: false
      });
    }
  }

  componentWillMount() {
    const name = getParsedRouteParam(this.props.match.params.club);
    const country = getParsedRouteParam(this.props.match.params.country);
    const state = getParsedRouteParam(this.props.match.params.state);

    this.setState({
      name,
      country,
      state
    });

    this.props.requestClubs({
      query: {
        name: { $regex: name, $options: "i" },
        country: { $regex: country, $options: "i" },
        state: { $regex: state, $options: "i" }
      }
    });

    this.findClub = this.findClub.bind(this);
  }

  componentDidMount() {
    this.props.history.listen((location, action) => {
      window.scrollTo(0, 0);
    });
  }

  componentWillUpdate(newProps) {
    if (this.props.clubs !== newProps.clubs) {
      this.findFixtures(newProps.clubs[0]._id);
    }
  }

  findFixtures(clubId) {
    if (!clubId) return;
    const currentYear = moment().year();
    const query = {
      query: {
        datetime: {
          $gte: moment([currentYear]).valueOf()
        },
        $or: [{ "home.id": clubId }, { "away.id": clubId }]
      }
    };

    this.props.requestFixtures(query);
  }

  findClub() {
    const clubs = this.props.clubs;

    if (clubs.length === 1 && Array.isArray(clubs)) {
      return clubs[0];
    }

    const club = _.find(clubs, club => {
      return (
        club.state.toLowerCase() === this.state.state.toLowerCase() &&
        club.country.toLowerCase() === this.state.country.toLowerCase() &&
        club.name.toLowerCase() === this.state.name.toLowerCase()
      );
    });

    return club;
  }

  render() {
    const club = this.findClub();
    const clubLabel = capitaliseFirstLetters(this.state.name);
    const stateLabel = capitaliseFirstLetters(this.state.state);
    const countryLabel = capitaliseFirstLetters(this.state.country);

    const description = `${clubLabel} is a GAA club based in ${stateLabel}, ${countryLabel}.`;

    return (
      <div className="page__outer-container">
        <header>
          <NavBar {...this.props} />
        </header>
        <Container>
          <Helmet>
            <title>{`${clubLabel} - ${stateLabel} | ${APP_NAME}`}</title>
            <meta name="description" content={description} />
            <link
              rel="canonical"
              href={`${BASE_URL}${window.location.pathname}`}
            />
            <meta
              property="og:title"
              content={`${clubLabel} - ${stateLabel} | ${APP_NAME}`}
            />
            <meta property="og:description" content={description} />
            <meta
              property="og:image"
              content={
                club
                  ? `${club.img}`
                  : "https://d3hfkx84ni8spj.cloudfront.net/misc/gaa-intl-lrg.png"
              }
            />
            <meta
              property="og:url"
              content={`${BASE_URL}${window.location.pathname}/`}
            />
            <meta property="og:type" content="website" />
            <script
              type="text/javascript"
              defer
              src="https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5afd0f9df1ffa724"
            />
          </Helmet>
          <Breadcrumb size="small">
            <Breadcrumb.Section href={HOME_ROUTE}>Home</Breadcrumb.Section>
            <Breadcrumb.Divider icon="right chevron" />
            <Breadcrumb.Section href={FIND_CLUB_ROUTE}>
              Find a club
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right chevron" />
            <Breadcrumb.Section
              href={`${CLUBS_ROUTE}/${this.props.match.params.country}`}
            >
              {countryLabel}
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right chevron" />
            <Breadcrumb.Section
              href={`${CLUBS_ROUTE}/${this.props.match.params.country}/${
                this.props.match.params.state
              }`}
            >
              {stateLabel}
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right chevron" />
            <Breadcrumb.Section active>{clubLabel}</Breadcrumb.Section>
          </Breadcrumb>
          <Divider />
          <div className="page__outer">
            {this.state.isLoading ? (
              <div className="spinner__container">
                <SyncLoader loading={true} margin="7px" color="#007849" />
              </div>
            ) : (
              <Club
                club={club}
                user={this.props.user}
                history={this.props.history}
                fixtures={this.props.fixtures}
              />
            )}
          </div>
        </Container>
        <Footer />
      </div>
    );
  }
}

ClubPage.defaultProps = {
  requestClubs: () => ({}),
  clubs: [],
  fixtures: []
};

ClubPage.propTypes = {
  requestClubs: PropTypes.func,
  clubs: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};



// WEBPACK FOOTER //
// ./src/routes/Club/View.js